(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-product-information"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-product-tabs')) {
  customElements.define('bb-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.panels = Array.from(this.querySelectorAll('.bb-tabs__panel'));
      this.nav = this.querySelector('.bb-tabs__nav');
      this.active = 0;
      this.buttons = this.panels.map((panel,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bb-tabs__tab';
        button.id = panel.id + '-tab';
        button.setAttribute('role','tab');
        button.setAttribute('aria-controls',panel.id);
        button.textContent = panel.querySelector('summary > span').textContent;
        button.addEventListener('click',() => this.select(index));
        button.addEventListener('keydown',event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.buttons.length - 1;
          else return;
          event.preventDefault();
          this.select(next);
          this.buttons[next].focus();
        });
        this.nav.append(button);
        return button;
      });
      this.nav.setAttribute('role','tablist');
      this.media = matchMedia('(min-width: 750px)');
      this.update = () => this.layout();
      this.media.addEventListener('change',this.update);
      this.layout();
    }
    disconnectedCallback() { this.media?.removeEventListener('change',this.update); this.ready = false; this.nav?.replaceChildren(); }
    select(index) { this.active = index; this.layout(); }
    layout() {
      const desktop = this.media.matches;
      this.toggleAttribute('data-desktop',desktop);
      this.buttons.forEach((button,index) => {
        button.setAttribute('aria-selected',String(index === this.active));
        button.tabIndex = index === this.active ? 0 : -1;
      });
      this.panels.forEach((panel,index) => {
        panel.hidden = desktop && index !== this.active;
        panel.open = index === this.active;
        if (desktop) {
          panel.setAttribute('role','tabpanel');
          panel.setAttribute('aria-labelledby',this.buttons[index].id);
          panel.tabIndex = 0;
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
